<template>
  <div class="token-body">
    <el-form
      :model="tokenForm"
      :rules="tokenRules"
      ref="ruleForm"
      label-width="100px"
      label-position="top"
      class="token-form"
    >
      <el-form-item>
        <div class="token-title">批量生成以太坊兼容链钱包</div>
      </el-form-item>

      <!-- <el-form-item label="公链" prop="publicChain" class="publicChain">
        <template slot="label">
          <div class="publicChain-label">
            <div class="">
              公链
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">选择公链</div>
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </div>
          
          </div>
        </template>
        <el-radio-group v-model="tokenForm.publicChain" @input="selectFunction">
          <el-radio
            v-for="(item, index) in tokenForm.publicChainOptions"
            :key="item.value"
            :label="item.name"
            :value="index"
            >{{ item.name }}</el-radio
          >
        </el-radio-group>
      </el-form-item> -->
      <!-- <el-form-item label="RPC 节点" prop="node">
        <el-input v-model="tokenForm.node" :disabled="true"></el-input>
      </el-form-item> -->

      <el-form-item label="钱包数量" prop="createWalletAmount">
        <el-input
          v-model="tokenForm.createWalletAmount"
          placeholder="请输入您要创建的钱包数量"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="success" plain @click="generateWalletsBatch()"
          >创建</el-button
        >
        <el-button
          type="success"
          icon="el-icon-download"
          @click="exportWallets()"
          :disabled="balances.length > 0 ? false : true"
          >导出</el-button
        >
      </el-form-item>

      <el-form-item v-if="balances.length > 0">
        <el-table
          class="balances-table"
          ref="multipleTable"
          :data="balances"
          tooltip-effect="dark"
          style="width: 100%"
          max-height="400"
          @selection-change="handleSelectionChange"
          empty-text="暂无数据"
          :key="true"
        >
          <el-table-column
            prop="address"
            label="公钥"
            min-width="35%"
          ></el-table-column>
          <el-table-column
            prop="privateKey"
            label="私钥"
            min-width="30%"
          ></el-table-column>
          <el-table-column
            prop="mnemonic"
            label="助记词"
            min-width="35%"
          ></el-table-column>
        </el-table>
      </el-form-item>
    </el-form>

    <LoadingAlert :visible.sync="showLoading"></LoadingAlert>
  </div>
</template>

<script>
import LoadingAlert from "@/components/alert/loading";
import { ethers } from "ethers";
import { nodeConfigs } from "@/config/config.js";
import {Worker} from "../../config/walletWorker.js";
import * as XLSX from "xlsx";
export default {
  components: {
    LoadingAlert,
  },
  data() {
    return {
      tokenForm: {
        node: nodeConfigs[0].rpc, // 节点
        symbol: nodeConfigs[0].symbol,
        publicChain: nodeConfigs[0].name, // 公链下拉选择框
        publicChainOptions: nodeConfigs,

        walletAddress: "", // 合约地址
        walletAddressError: "",
        lineNumber: 1, // 行数
        lineNumberError: 1,
        walletAddressExample:
          "0xd41b9AC5767cd90AbC7C997730591cBb7223D3D9\n0x08e4f54c59E65AFe43Da872486dfeC61e87dF200",
        checkError: false, // 检测格式错误

        createWalletAmount: 1,
      },
      tokenRules: {
        createWalletAmount: [
          {
            required: true,
            message: "创建钱包的数量不能为空",
            trigger: "blur",
          },
        ],
      },

      regex: /^[a-zA-Z0-9]{42}$/, // 正则判断

      provider: null,
      balances: [],
      multipleSelection: [],

      showLoading: false, // 遮罩层
    };
  },
  mounted() {
    // 使用Etherscan等公共节点创建一个provider
    //this.provider = new ethers.providers.JsonRpcProvider(this.tokenForm.node);
  },
  methods: {
    // 选择公链
    // selectFunction(value) {
    //   console.log("selectFunction=", value);
    //   var data = this.tokenForm.publicChainOptions.filter(
    //     (item) => item.name == value
    //   );
    //   if (!data || data.length == 0) {
    //     return;
    //   }
    //   this.tokenForm.node = data[0].rpc;
    //   this.tokenForm.symbol = data[0].symbol;
    //   console.log(this.tokenForm.symbol, this.tokenForm.node);
    //   this.provider = new ethers.providers.JsonRpcProvider(this.tokenForm.node);
    // },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建钱包
    generateWalletsBatch() {
      this.showLoading = true;
      this.balances = [];
      for (let i = 0; i < this.tokenForm.createWalletAmount; i++) {
        const wallet = ethers.Wallet.createRandom();
        const item = {
          address: wallet.address,
          privateKey: wallet.privateKey,
          mnemonic: wallet.mnemonic.phrase,
        };
        console.log(item)
        this.balances.push(item);
      }
      this.showLoading = false;
    },
    async createRandomWalletAsync() {
      return new Promise((resolve, reject) => {
        try {
          const wallet = ethers.Wallet.createRandom();
          resolve(wallet);
        } catch (error) {
          reject(error);
        }
      });
    },
    // 导出钱包
    exportWallets() {
      const data = this.balances.map((item) => ({
        address: item.address,
        privateKey: item.privateKey,
        mnemonics: item.mnemonics,
      }));
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "exported_table.xlsx");
    },
  },
};
</script>

<style lang="scss" scoped>
.token-body {
  width: calc(100% - 30%);
  height: 100%;
  background: #1f1f1f;
  border-radius: 20px 20px 20px 20px;

  padding: 0 15% 0 15%;

  .token-form {
    width: 100%;
    margin: 20px 0 0 0;

    .token-title {
      font-weight: normal;
      font-size: 20px;
      color: #8f8f8f;
      line-height: 23px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin: 4% 0 0 0;
    }

    .token-node {
      font-weight: normal;
      font-size: 18px;
      color: #8f8f8f;
      line-height: 21px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin: 54px 0 0 0;
    }

    /deep/.el-input__inner {
      height: 46px;

      background: #292929;
      border-radius: 4px 4px 4px 4px;
      border: none;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    /deep/.el-textarea__inner {
      background: #292929;
      border-radius: 4px 4px 4px 4px;
      border: none;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    /deep/.el-input__count {
      background: #292929;
      border-radius: 4px 4px 4px 4px;
      border: none;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    /deep/.el-form-item__label {
      font-weight: normal;
      font-size: 14px;
      color: #8f8f8f;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    /deep/.el-input-group__append {
      background: #3d3d3d;
      border-radius: 0px 4px 4px 0px;
      border: none;

      font-weight: normal;
      font-size: 16px;
      color: #939393;
      line-height: 19px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    /deep/.el-select-dropdown {
      width: 198px;
      // background: #d9d9d9;
      border-radius: 8px 8px 8px 8px;
      font-weight: 400;
      font-size: 14px;
      color: #8f8f8f;
      line-height: 16px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      top: 65px !important;
    }
    /deep/.el-select-dropdown__item:hover {
      background: rgba(77, 77, 77, 0.5);
      color: #d8d8d8;
    }
    /deep/.el-select-dropdown__item.selected {
      color: #675aff;
    }
    /deep/.popper__arrow {
      left: 93px !important;
    }

    .publicChain {
      width: 100%;
      /deep/.el-form-item__label {
        width: 100% !important;
      }

      .publicChain-label {
        width: 100%;
        max-width: 215px;
        white-space: nowrap;

        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }

    .balances-table {
      margin: 0 0 54px 0;
      /* 为所有滚动条设置样式 */
      ::-webkit-scrollbar {
        width: 6px; /* 设置滚动条的宽度 */
        height: 10px; /* 设置滚动条的高度 */
      }

      /* 滚动条轨道 */
      ::-webkit-scrollbar-track {
        background: transparent; /* 设置轨道的背景颜色 */
      }

      /* 滚动条的滑块 */
      ::-webkit-scrollbar-thumb {
        background: #888; /* 设置滑块的背景颜色 */
        border-radius: 5px 5px;
      }

      /* 当鼠标悬停在滑块上 */
      ::-webkit-scrollbar-thumb:hover {
        background: #555; /* 设置滑块在悬停状态下的背景颜色 */
        cursor: pointer;
      }
    }
  }
}

/* 为所有滚动条设置样式 */
::-webkit-scrollbar {
  width: 6px; /* 设置滚动条的宽度 */
  height: 10px; /* 设置滚动条的高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: transparent; /* 设置轨道的背景颜色 */
}

/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background: #888; /* 设置滑块的背景颜色 */
  border-radius: 5px 5px;
}

/* 当鼠标悬停在滑块上 */
::-webkit-scrollbar-thumb:hover {
  background: #555; /* 设置滑块在悬停状态下的背景颜色 */
  cursor: pointer;
}
</style>